import { render } from "./OrderCellOrderNumber.vue?vue&type=template&id=67990824&scoped=true"
import script from "./OrderCellOrderNumber.vue?vue&type=script&lang=js"
export * from "./OrderCellOrderNumber.vue?vue&type=script&lang=js"

import "./OrderCellOrderNumber.vue?vue&type=style&index=0&id=67990824&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67990824"]])

export default __exports__